import { useEffect, useState } from "react";
import { SingleValue } from "react-select";
import { ISendTestNotficationData } from "../../../../services/api/email-content-service";
import FontBody1 from "../../../../components/fonts/font-body1/font-body1";
import FontBody2 from "../../../../components/fonts/font-body2/font-body2";
import { FONT_COLOR, FONT_VARIANT } from "../../../../components/fonts/font-props";
import { BUTTON_VARIANTS } from "../../../../components/inputs/button-variants";
import { Button } from "../../../../components/inputs/button/button";
import { IOption, SelectDropdown } from "../../../../components/inputs/select-dropdown/select-dropdown";
import { Textarea } from "../../../../components/inputs/textarea/textarea";
import { DefaultModalLayout } from "../../../../components/modal/layouts/default-modal-layout";
import './notification-test-modal.scss';

const LEGACY_SERVICE_CODE: string[] = ['ReturnGO']
interface INotificationTestModalProps {
    title?: string,
    selectedServiceCode: SingleValue<IOption>,
    channels: IOption[],
    eventName: string,
    setTestNotificationData: (value: ISendTestNotficationData) => Promise<string|undefined>,
    sendButton?: {
        title: string,
        onClick: (message: string) => void
    },
    discardButton?: {
        title: string,
        onClick: () => void
    }
}


export const NotificationTestModal: React.FC<INotificationTestModalProps> = ({
    title,
    setTestNotificationData,
    channels,
    eventName,
    selectedServiceCode,
    sendButton = {
        title: 'Send',
        onClick: () => { },
    },
    discardButton = {
        title: 'Discard',
        onClick: () => { },
    }
}) => {
    const [testEmail, setTestEmail] = useState('');
    const [selectedChannel, setSelectedChannel] = useState<SingleValue<IOption>>();
    const [isEmailValid, setIsEmailValid] = useState(false)
    const [filteredChannel, setFilterdChannel] = useState<IOption[]>([])
    const [showChannels, setShowChannels] = useState(true)
    const [isSending, setIsSending] = useState<boolean>(false);

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    const checkEmailValidation = (text: string) => {

        const emails = text.split(',').map(email => emailRegex.test(email.trim()));

        for (let isValid of emails) {
            if (!isValid) {
                setIsEmailValid(false);
                return;
            }
        }

        setIsEmailValid(true);
    }
    useEffect(() => {
        let filteredChannels: any[] = [];
        if (channels.length > 1) {
            filteredChannels = channels.filter(channel => channel.label.length > 0);
        } else {
            filteredChannels = [channels[0]];
        }
        const optionsForTest: IOption[] = [...filteredChannels[0].options].filter(channel => channel.value !== 'off');
        setFilterdChannel(optionsForTest);
        setShowChannels(optionsForTest.length > 1)
        setSelectedChannel(optionsForTest[0]);
    }, [channels, setFilterdChannel, setShowChannels, setSelectedChannel]);

    const handleSendClick = async () => {
        setIsSending(true);
        const testNotificationData = {} as ISendTestNotficationData;
        testNotificationData.toAddresses = testEmail.split(",").map((value) => value.trim());
        testNotificationData.serviceCode = selectedChannel?.value as string;
        await setTestNotificationData(testNotificationData);
        const message = (!LEGACY_SERVICE_CODE.includes(selectedChannel?.value as string)) ?
            `A test ${eventName} event was successfully sent to the following ${selectedChannel?.label} profiles: ${testEmail}` :
            `A test ${eventName} notification was successfully sent to the following email addresses: ${testEmail}`;
        sendButton?.onClick(message);
        setIsSending(false);
    }

    return (
        <DefaultModalLayout onCloseClicked={() => discardButton?.onClick()} isCloseDisabled={false}>
            <div className="notification-test-modal">
                {title && <div className="notification-test-modal-title">
                    <FontBody1 color={FONT_COLOR.NEUTRAL3}>{title}</FontBody1>
                </div>}
                <div style={{ display: (showChannels) ? '' : 'none' }}>
                    <FontBody2 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD} >Channel: </FontBody2>
                    <SelectDropdown
                        value={selectedChannel}
                        options={filteredChannel}
                        onChange={(o) => setSelectedChannel(o)} />
                </div>
                <div className="notification-test-modal-text">
                    <FontBody1 color={FONT_COLOR.PRIMARY3}>
                        {
                            (!LEGACY_SERVICE_CODE.includes(selectedChannel?.value as string)) ?
                                <div>
                                    <div>
                                        Send a test event to selected profiles in your {selectedChannel?.label} account.</div>
                                    <div>
                                        Note: The event is sent with sample data.
                                    </div>
                                </div> :
                                <div>
                                    <div>Send a test email to the selected address.</div>
                                    <div>Note: The email is sent with sample data.</div>
                                </div>
                        }</FontBody1>
                </div>
                <div>
                    <FontBody2 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>{(!LEGACY_SERVICE_CODE.includes(selectedChannel?.value as string)) ?
                        `${selectedChannel?.label} Profile Email Addresses:` :
                        `Email Addresses:`}</FontBody2>
                    <Textarea
                        value={testEmail}
                        onChange={(text: any) => { setTestEmail(text); checkEmailValidation(text); }}
                        placeholder={'Type email addresses separated by commas'}
                    />
                </div>
                <div className="notification-test-modal-buttons">
                    <Button disabled={isSending} text={discardButton?.title} onClick={discardButton?.onClick} variant={BUTTON_VARIANTS.Tertiary} />
                    <Button hasLoader isLoading={isSending} text={sendButton?.title} onClick={handleSendClick} disabled={!isEmailValid} variant={BUTTON_VARIANTS.Primary} />
                </div>
            </div>
        </DefaultModalLayout>
    );
}
